<template>
  <b-container class="my-4">
    <b-row>
      <b-col>
        <h5
          class="mb-3"
          style="text-align: center"
        >
          Change the artwork at the top to change the styling of the below pictures.
        </h5>
        <div
          style="width:200px;margin: auto"
        >
          <b-carousel
            v-model="styleNumber"
            :interval="0"
            controls
            indicators
          >
            <b-carousel-slide
              v-for="style in styles"
              :key="style"
              :img-src="require('./assets/style/' + style + '.jpg')"
            />
          </b-carousel>
        </div>
        <b-container class="my-3">
          <b-row>
            <b-col
              v-for="content in contents"
              :key="content"
            >
              <b-carousel
                v-model="styleNumber"
                :interval="0"
              >
                <b-carousel-slide
                  v-for="style in styles"
                  :key="style"
                  :img-src="require('./assets/output/' + content + '_' + style + '.jpg')"
                />
              </b-carousel>
            </b-col>
          </b-row>
        </b-container>

        <div
          class="mt-4"
          style="text-align: center"
        >
          <div id="visitorImg"></div>
          <b-button
            class="mt-2"
            v-b-modal.upload-image-modal
            size="lg"
          >
            <template v-if="working">
              <b-spinner size="sm" />
              Working...
            </template>
            <template v-else>
              Upload image
            </template>
          </b-button>
          <b-alert
            v-model="showAlert"
            variant="danger"
            dismissible
          >
            An error occurred. Ensure that the style is different from "original", that the 
            uploaded file is png/jpg, and that the size is less than 20 MB.
          </b-alert>
        </div>

        <div class="my-5">
          <h4>What is going on?</h4>
          <p>
            What you see above is called "style transfer" and it is one of my absolute favorite
            applications of deep learning. In style transfer, you take the local structure of one image
            (the style image) and apply it to another (the content image), thereby creating a third (the
            output image). From the perspective of a convolutional neural network this means
            that the style image and the output image must activate the first few layers of the
            network in a similar fashion, while later layers must activate similarly for the content
            image and output image. You simply put this into a loss function
            (<a href="http://openaccess.thecvf.com/content_cvpr_2016/papers/Gatys_Image_Style_Transfer_CVPR_2016_paper.pdf">link</a>)
            and then vary the pixels of your output image to minimize the loss - out comes
            pretty pictures!
          </p>
          <p>
            This process is a bit too heavy to allow you guys to upload images to my
            tiny cloud server. Therefore, I here use an approach developed later on
            (<a href="https://arxiv.org/abs/1603.08155">link</a>)
            that trains a transformer network to output images that minimizes the loss function
            described above for a particular style image.
          </p>
          <p>
            There is also a third way to do style transfer which is based on CycleGANs. This method
            can also be used to turn horses into zebras and art into photos - you should definately
            <a href="https://github.com/junyanz/CycleGAN">check it out.</a>
          </p>
        </div>

        <b-modal
          id="upload-image-modal"
          title="Upload image"
          ok-title="Upload"
          @ok="uploadImage"
        >
          <b-form-group
            label="Choose a png/jpg image"
            label-for="upload-image-file-form"
            description="The transformer will use the style currently shown on the page. Note that
              the images will be scaled down due to processing constraints on the server. The local
              structure of the style image will therefore manifest itself at larger scale in your
              input image so that close-ups looks best."
          >
            <b-form-file
              id="upload-image-file-form"
              v-model="file"
              accept=".jpg, .png"
            />
          </b-form-group>
        </b-modal>
      </b-col>
    </b-row>
  </b-container>
</template>

<script>

import axios from 'axios';
import { endpoints } from '../constants';

export default {
  name: 'songWriter',
  data() {
    return {
      styleNumber: 0,
      styles: ['candy', 'udnie', 'mosaic', 'rain', 'original'],
      contents: ['tower', 'food', 'foot'],
      file: null,
      working: false,
      showAlert: null,
      visitorImg: null,
    };
  },
  methods: {
    async uploadImage() {
      const style = this.styles[this.styleNumber];
      if (style === 'original' || this.file === null) {
        this.showAlert = true;
        return;
      }
      const formData = new FormData();
      formData.append('style', style);
      formData.append('file', this.file);
      this.working = true;
      try {
        const resp = await axios.post(endpoints.styleTransfer, formData);
        let src = 'data:image/jpeg;base64,';
        src += resp.data;
        const newImage = document.createElement('img');
        newImage.src = src;
        document.querySelector('#visitorImg').innerHTML = newImage.outerHTML;
      } catch (e) {
        this.showAlert = true;
        console.log('Upload failed:', e);
      }
      this.working = false;
    },
  },
};
</script>

<style scoped>

</style>
